import styled from '@emotion/styled';
import { COLORS } from '@sortlist-frontend/design-system/legacy';

export const LocationSelectorWrapper = styled.div`
  .location-anywhere {
    &:hover {
      color: ${COLORS.NEUTRAL_100} !important;
      background: ${COLORS.PRIMARY_500} !important;
    }
  }
`;
